<template>
    <div class="customer-name">
        <IconBase icon-name="personal-details" class="icon icon--customer" />
        <span class="name">{{ displayName }}</span>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import IconBase from '@/components/global/icon-base';

export default {
    name: 'CustomerName',
    components: {
        IconBase,
    },
    computed: {
        ...mapGetters({ customerName: 'user/customerName' }),
        ...mapState({ customerEmail: state => state.user.customer.email }),
        displayName() {
            return this.customerName || this.customerEmail;
        },
    },
};
</script>

<style lang="scss" scoped>
.customer-name {
    background-color: $color-highlight;
    box-shadow: $shadow-1;
    z-index: 60;
    text-align: center;
    padding: 0.5rem 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.25rem;
    color: $color-font-light;
    .icon--customer {
        display: inline-block;
        width: 1.25rem;
        margin-right: 0.5rem;
    }
    .name {
        margin-left: 0.5rem;
        font-weight: $font-weight-bold;
    }
}
</style>
